import { Injectable } from "@angular/core";
import { EnvService } from "./env.service";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { BehaviorSubject, Observable, Subject } from "rxjs";
import { SocketsService } from "./views/sockets.service";
import { TranslateService } from "@ngx-translate/core";
import { AuthService } from "./auth.service";
import { ChunkService } from "./views/content/chunk/chunk.service";
import { ToastService } from "./shared/services/toast/toast.service";
let httpOptions = {
  headers: new HttpHeaders({
    "Content-Type": "application/json", //,
    // 'x-auth': ()
  }),
};
@Injectable({
  providedIn: "root",
})
export class CallService {
  url = this.env.apiUrl;
  private localStream: MediaStream | null = null;
  private peerConnection!: RTCPeerConnection;
  private remoteStreamSubject = new Subject<any>();
  private callStateSource = new BehaviorSubject("disconnected");
  callState$ = this.callStateSource.asObservable();
  private callEventsSource = new BehaviorSubject("disconnected");
  callEvents$ = this.callEventsSource.asObservable();
  private deviceChangeSource = new BehaviorSubject({
    microphone: null,
    camera: null,
  });
  deviceChangeEvent$ = this.deviceChangeSource.asObservable();

  destination;
  tracksInfo = [];
  hasStartedIt = false;
  displayStream;
  remoteStream: MediaStream;
  speakerDetails = [];
  extractedLocalAudioStream: MediaStream;
  remoteDisplayStream: MediaStream;
  unidentifiedStreams: MediaStream[] = [];
  liveTranscriptionDuration = { seconds: 0 };
  userConfiguration;
  selectedMicrophone;
  transcriptionSettings;
  constructor(
    private env: EnvService,
    private http: HttpClient,
    private socketService: SocketsService,
    private translate: TranslateService,
    private authService: AuthService,
    private chunkService: ChunkService,
    private envService: EnvService,
    private toast: ToastService
  ) {
    this.userConfiguration = this.authService.userConfiguration$.subscribe(
      (res) => {
        this.selectedMicrophone =
          localStorage.getItem("selectedMicrophone") || "";
        if (res.transcriptionSettings) {
          this.transcriptionSettings = res.transcriptionSettings;
        }
      },
    );
    this.socketService.streamEvent$.subscribe(async (res) => {
      switch (res.type) {
        case "call-transcription-data":
          this.liveTranscriptionDuration.seconds = Number(
            res.data?.raw?.totalBilledTime?.seconds || 0,
          );
          break;
        case "remote-track-information":
          const trackInfo = res.data;
          this.tracksInfo.push(trackInfo);
          /*  for (let stream of this.unidentifiedStreams) {
            if (stream.getTrackById(trackInfo.id)) {
              if (trackInfo?.type == "camera") {
                this.remoteStream = stream;
                this.remoteStream.onremovetrack = (event) => {
                  const track = event.track;
                  if (track.kind == "video") {
                    this.passCallEvent("stream-camera-feed-ended");
                  } else if (track.kind == "audio") {
                    this.closeConnection();
                  }
                };
                this.remoteStreamSubject.next({
                  stream,
                  trackInfo,
                });
              } else if (trackInfo?.type == "screen") {
                this.remoteDisplayStream = stream;
                this.remoteDisplayStream.onremovetrack = (event) => {
                  this.passCallEvent("screen-sharing-ended");
                };
                this.remoteStreamSubject.next({
                  stream,
                  trackInfo,
                });
              }
            }
          } */
          break;
        case "call-ice-candidate":
          if (this.peerConnection) {
            this.peerConnection.addIceCandidate(
              new RTCIceCandidate(res.data.candidate),
            );
          }
          break;
        case "call-answer":
          if (this.peerConnection) {
            this.peerConnection.setRemoteDescription(
              new RTCSessionDescription(res.data.answer),
            );
          }
          break;
        case "call-offer":
          if (!this.peerConnection) {
            this.createPeerConnection(res.data.destination);
          }
          if (this.peerConnection) {
            await this.peerConnection.setRemoteDescription(
              new RTCSessionDescription(res.data.offer),
            );
            this.peerConnection
              .createAnswer()
              .then(async (answer) => {
                await this.peerConnection.setLocalDescription(answer);
                this.socketService.emitEvent("call-answer", {
                  destination: res.data.destination,
                  answer,
                });
              })
              .catch((err) => {
                console.error(err);
              });
          }
          break;
      }
    });
  }
  passDeviceChange(data) {
    this.deviceChangeSource.next(data);
  }
  addScreenRecordingToCall() {
    return new Promise(async (resolve, reject) => {
      try {
        if (!this.peerConnection) reject(null);
        this.displayStream = await (
          navigator.mediaDevices as any
        ).getDisplayMedia({
          video: true,
          audio: false,
        });
        this.displayStream.getTracks().forEach((track) => {
          this.socketService.emitEvent("remote-track-information", {
            type: "screen",
            kind: track.kind,
            id: track.id,
            destination: this.destination,
          });
          this.peerConnection.addTrack(track, this.displayStream);
        });
        resolve(this.displayStream);
      } catch (err) {
        reject(err);
        console.error(err);
      }
    });
  }
  stopSharingScreen() {
    this.socketService.emitEvent("screen-recording-ended", {
      destination: this.destination,
    });
    this.displayStream.getTracks().forEach((track) => {
      this.peerConnection.getSenders().forEach((sender) => {
        if (sender.track.id == track.id) {
          this.peerConnection.removeTrack(sender);
        }
      });

      track.stop();
    });
  }

  getCall(data): Observable<any> {
    return this.http.post(this.url + "call/getCall/", data, httpOptions);
  }

  createCall(data): Observable<any> {
    return this.http.post(this.url + "call/create", data, httpOptions);
  }

  endCall(callID): Observable<any> {
    return this.http.get(this.url + "call/endCall/" + callID, httpOptions);
  }

  listenToHostChanges(callID) {
    const evtSource = new EventSource(
      this.url +
        `call/waitForHost?callID=${callID}&app_name=${this.envService.appName}`,
      {},
    );
    return evtSource;
  }

  setSocketID(data): Observable<any> {
    return this.http.post(
      this.url + "call/set-caller-socket-id",
      data,
      httpOptions,
    );
  }
  inviteToCall(data): Observable<any> {
    return this.http.post(this.url + "call/invite", data, httpOptions);
  }

  generateZoomVideoSignature(data): Observable<any> {
    return this.http.post(
      this.url + "call/generateZoomVideoKey/",
      data,
      httpOptions,
    );
  }

  getZoomRecordings(data): Observable<any> {
    return this.http.post(
      this.url + "call/getZoomCloudRecordings/",
      data,
      httpOptions,
    );
  }
  passCallEvent(data) {
    this.callEventsSource.next(data);
  }
  getEmptyVideoStream() {
    return new Promise((resolve, reject) => {
      const imageElement = document.createElement("img");
      imageElement.src = "assets/images/no_user.png";
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
      const timeout = setTimeout(() => {
        reject();
      }, 5000);
      imageElement.onload = () => {
        ctx.drawImage(imageElement, 0, 0, canvas.width, canvas.height);
        const stream = canvas.captureStream(25);
        clearTimeout(timeout);
        resolve(stream);
      };
      imageElement.onerror = () => {
        clearTimeout(timeout);
        reject();
      };
    });
  }

  getLocalCameraStream() {
    return new Promise(async (resolve, reject) => {
      const selectedCamera = localStorage.getItem("selectedCamera");
      const selectedMicrophone = localStorage.getItem("selectedMicrophone");
      if (!selectedMicrophone) {
        reject();
      }
      try {
        var localStream = await navigator.mediaDevices.getUserMedia({
          video: selectedCamera
            ? {
                deviceId: selectedCamera,
              }
            : false,
          audio: {
            echoCancellation: { exact: true },
            deviceId: selectedMicrophone,
          },
        });
        if (!selectedCamera) {
          const emptyCameraStream =
            (await this.getEmptyVideoStream()) as MediaStream;
          localStream = this.combineStreams(localStream, emptyCameraStream);
          localStream.addTrack(emptyCameraStream.getVideoTracks()[0]);
        }
        resolve(localStream);
      } catch (err: any) {
        if (err.name === 'NotAllowedError' || err.message?.includes('Permission denied')) {
            this.toast.showDevicePermissionError();
        } else {
            this.toast.snackbar.open(this.translate.instant('Snackbar.Error') || 'An error occurred', 'OK', { duration: 3000 });
        }
        reject(err);
      }
    });
  }
  async stopAllMediaStreams(): Promise<void> {
    try {
      const devices = await navigator.mediaDevices.enumerateDevices();
      const activeTracks = devices.filter(
        (device): device is MediaDeviceInfo =>
          device.kind === "videoinput" || device.kind === "audioinput",
      );
      for (const track of activeTracks) {
        const stream = await navigator.mediaDevices.getUserMedia({
          video:
            track.kind === "videoinput"
              ? { deviceId: { exact: track.deviceId } }
              : false,
          audio:
            track.kind === "audioinput"
              ? { deviceId: { exact: track.deviceId } }
              : false,
        });
        stream.getTracks().forEach((t) => {
          if (t.readyState === "live") {
            t.stop();
            console.log("stopping active track", t);
          }
        });
      }
    } catch (error) {
      console.error("Error stopping media streams:", error);
    }
  }
  combineStreams(audioStream: MediaStream, videoStream: MediaStream) {
    const combinedStream = new MediaStream();
    videoStream
      .getVideoTracks()
      .forEach((track) => combinedStream.addTrack(track));
    audioStream
      .getAudioTracks()
      .forEach((track) => combinedStream.addTrack(track));

    /*     videoStream.getTracks().forEach((track) => {
      track.stop();
    });
    audioStream.getTracks().forEach((track) => {
      track.stop();
    }); */
    return combinedStream;
  }
  updateCameraStream() {
    return new Promise(async (resolve, reject) => {
      if (!this.localStream || !this.peerConnection) {
        resolve(null);
        return;
      }
      const stream = (await this.getLocalCameraStream()) as MediaStream;
      const getNewTrack = (kind) => {
        return stream.getTracks().find((track) => track.kind == kind);
      };
      for (let track of this.localStream.getTracks()) {
        const sender = this.peerConnection
          .getSenders()
          .find((s) => s?.track?.id == track?.id);
        await sender.replaceTrack(getNewTrack(track.kind));
        track.stop();
      }
      if (!this.localStream.getVideoTracks().length) {
        const videoTrack = stream.getVideoTracks()[0];
        if (videoTrack) {
          this.socketService.emitEvent("remote-track-information", {
            type: "camera",
            kind: videoTrack.kind,
            id: videoTrack.id,
            destination: this.destination,
          });
          this.peerConnection.addTrack(videoTrack, stream);
        }
      }
      this.localStream = stream;
    });
  }

  startCall(destination): Promise<void> {
    return new Promise(async (resolve, reject) => {
      try {
        this.hasStartedIt = true;
        this.localStream = (await this.getLocalCameraStream()) as MediaStream;
        this.createPeerConnection(destination);
        this.localStream.getTracks().forEach((track) => {
          this.socketService.emitEvent("remote-track-information", {
            type: "camera",
            kind: track.kind,
            id: track.id,
            destination: destination,
          });
          this.peerConnection.addTrack(track, this.localStream!);
        });

        resolve();
      } catch (err) {
        console.error(err);
        reject(err);
      }
    });
  }

  getRemoteStream(): Observable<any> {
    return this.remoteStreamSubject.asObservable();
  }

  closeConnection(alsoEmit = true) {
    if (this.peerConnection) {
      this.stopTranscribingCall();
      this.peerConnection.close();
      this.peerConnection = null;
      this.stopAllMediaStreams();
      this.callStateSource.next("disconnected");
      if (this.localStream)
        this.localStream.getTracks().forEach((track) => {
          track.stop();
        });
      if (this.displayStream)
        this.displayStream.getTracks().forEach((track) => {
          track.stop();
        });
      if (this.remoteStream)
        this.remoteStream.getTracks().forEach((track) => {
          track.stop();
        });
      if (this.remoteDisplayStream)
        this.remoteDisplayStream.getTracks().forEach((track) => {
          track.stop();
        });
      if (this.extractedLocalAudioStream) {
        this.extractedLocalAudioStream.getTracks().forEach((track) => {
          track.stop();
        });
      }
      if (alsoEmit) {
        this.socketService.emitEvent("end-call", {
          destination: this.destination,
        });
      }
      this.socketService.closeSocket();
    }
  }
  async joinCallAudioVideo() {
    const selectedMicrophone = localStorage.getItem("selectedMicrophone");
    const selectedCamera = localStorage.getItem("selectedCamera");

    this.localStream = (await this.getLocalCameraStream()) as MediaStream;

    this.localStream.getTracks().forEach((track) => {
      this.socketService.emitEvent("remote-track-information", {
        type: "camera",
        kind: track.kind,
        id: track.id,
        destination: this.destination,
      });
      this.peerConnection.addTrack(track, this.localStream);
    });
  }

  extractAudioFromVideoStream(videoStream) {
    const audioStream = new MediaStream();
    videoStream.getAudioTracks().forEach((track) => {
      audioStream.addTrack(track);
    });
    return audioStream;
  }

  stopTranscribingCall() {
    this.speakerDetails.forEach((element, index) => {
      if (this.speakerDetails[index].recorder)
        this.speakerDetails[index].recorder.stop();
    });
    this.chunkService
      .finalizeLiveTranscription({
        model: this.transcriptionSettings.model,
        ...this.liveTranscriptionDuration,
      })
      .subscribe({
        next: (res) => {},
        error: (err) => console.error(err),
      });
    setTimeout(() => {
      this.socketService.emitEvent("stop-call-recording", {});
    }, 1000);
  }

  startTranscribingCall() {
    const wait = (time) => {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve(true);
        }, time);
      });
    };

    this.extractedLocalAudioStream = this.extractAudioFromVideoStream(
      this.localStream,
    );
    this.speakerDetails = [
      {
        speaker: 0,
        recorder: new MediaRecorder(this.extractedLocalAudioStream),
      },
      {
        speaker: 1,
        recorder: new MediaRecorder(this.remoteStream),
      },
    ];
    for (const element of this.speakerDetails) {
      element.recorder.start(500);
      element.recorder.ondataavailable = async (event) => {
        this.socketService.emitEvent("transcribe-call-data", {
          speaker: element.speaker,
          data: await event.data.arrayBuffer(),
          language: this.translate.currentLang,
        });
        await wait(250);
      };
    }
  }

  private createPeerConnection(destination): RTCPeerConnection {
    this.destination = destination;
    this.peerConnection = new RTCPeerConnection({
      iceServers: [{ urls: "stun:stun.l.google.com:19302" }],
    });
    this.peerConnection.onconnectionstatechange = (event) => {
      //console.log(this.peerConnection.connectionState);
      this.callStateSource.next(this.peerConnection.connectionState);
    };
    this.peerConnection.onicecandidate = (event) => {
      if (event.candidate) {
        this.socketService.emitEvent("call-ice-candidate", {
          destination,
          candidate: event.candidate,
        });
      }
    };
    this.peerConnection.onnegotiationneeded = async (event) => {
      const offer = await this.peerConnection.createOffer();
      await this.peerConnection.setLocalDescription(offer);
      this.socketService.emitEvent("call-offer", { destination, offer });
    };
    this.peerConnection.ontrack = (event) => {
      const trackInfo = this.tracksInfo.find((track) =>
        event.streams[0].getTrackById(track.id),
      );
      if (trackInfo?.type == "camera") {
        this.remoteStream = event.streams[0];
        this.remoteStream.onremovetrack = (event) => {
          const track = event.track;
          if (track.kind == "video") {
            this.passCallEvent("stream-camera-feed-ended");
          } else if (track.kind == "audio") {
            this.closeConnection();
          }
        };
        this.remoteStreamSubject.next({ stream: event.streams[0], trackInfo });
      } else {
        this.remoteDisplayStream = event.streams[0];
        this.remoteDisplayStream.onremovetrack = (event) => {
          this.passCallEvent("screen-sharing-ended");
        };
        this.remoteStreamSubject.next({ stream: event.streams[0], trackInfo });
      } /* else {
        this.unidentifiedStreams.push(event.streams[0]);
      } */

      if (!this.hasStartedIt) {
        //this.addScreenRecordingToCall();
        this.joinCallAudioVideo();
      }
    };

    return this.peerConnection;
  }
}
